import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { PlannedServiceDetailsComponent } from "./plannedService-details.component";
import { PipeModule } from "app/pipes/pipe.module";

@NgModule({
  declarations: [
    PlannedServiceDetailsComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    PipeModule
  ]
})
export class PlannedServiceDetailsModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/plannedService/details/plannedService-details.module.ts